import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import zipFile from "../assets/Commercial Cleaning Marketing Kit.zip";
import { Helmet } from "react-helmet-async";

export default function MarketingKit() {
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleDownload();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    const response = await fetch(zipFile);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Commercial Cleaning Marketing Kit.zip";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    setIsDownloading(false);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
        <title>Marketing Kit</title>
      </Helmet>
      <div className="relative bg-[#F8F8F8] overflow-hidden min-h-screen">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-10 left-10 w-16 h-16 bg-[#4E6978]/10 rounded-full animate-bounce" />
          <div className="absolute top-32 right-20 w-12 h-12 bg-[#F09900]/10 rounded-full animate-bounce" />
          <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-[#4E6978]/8 rounded-full animate-bounce" />
          <div className="absolute top-1/2 right-10 w-8 h-8 bg-[#F09900]/15 rounded-full animate-bounce" />
          <div className="absolute bottom-32 right-1/3 w-14 h-14 bg-[#4E6978]/10 rounded-full animate-bounce" />
        </div>
        <div className="relative z-10 container mx-auto min-h-screen flex items-center justify-center p-6">
          <div className="w-full max-w-2xl rounded-xl shadow-2xl bg-gray-50 border-3 border-[#4E6978] overflow-hidden">
            <div className="bg-slate-100 px-6 py-4 border-b border-slate-200">
              <span className="text-xl font-medium mt-2 text-[#4E6978]">
                Marketing Kit
              </span>
            </div>
            <div className="px-8 py-10">
              <div className="flex items-start gap-4">
                <div className="shrink-0">
                  <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#F09900]/10">
                    <Download className="h-8 w-8 text-[#F09900]" />
                  </span>
                </div>
                <div>
                  <p className="text-[#F09900] font-semibold leading-tight">
                    Your download is ready!
                  </p>
                  <h1 className="text-2xl font-extrabold text-slate-800 tracking-tight">
                    Commercial Cleaning Marketing Kit
                  </h1>
                </div>
              </div>
              <div className="mt-8 space-y-4 leading-7 text-[16px] font-medium text-[#4E6978]">
                <p>
                  Your marketing kit is downloading automatically. It contains
                  everything you need to promote your commercial cleaning
                  business.
                </p>
                <p>
                  If the download doesn't start automatically, click the button
                  below.
                </p>
              </div>
              <div className="mt-8 flex justify-center">
                <button
                  onClick={handleDownload}
                  disabled={isDownloading}
                  className="bg-[#F09900] hover:bg-[#e08800] text-white font-bold py-4 px-8 rounded-full text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {isDownloading ? (
                    <div className="flex items-center justify-center text-white text-xl">
                      <span className="animate-spin mr-2">⏳</span>
                      Preparing Download...
                    </div>
                  ) : (
                    <div className="flex items-center justify-center text-white text-xl">
                      <Download className="mr-2 h-6 w-6" />
                      Download Marketing Kit
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

